import { SecurityTeamItem } from "./SecurityTeamItem";

export default SecurityTeamItem;
